import { EventEmitter } from 'events';
import AwaitEventEmitter from './Utils/AwaitEventEmitter';

export class BaseComponent {
    private eventEmitter: EventEmitter;
    private awaitEventEmitter: AwaitEventEmitter;

    constructor() {
        this.eventEmitter = new EventEmitter();
        this.awaitEventEmitter = new AwaitEventEmitter();
    }

    on(eventName: string, handler: any): BaseComponent {
        this.eventEmitter.on(eventName, handler);

        return this;
    }

    emit(eventName: string, ...args: any[]) {
        this.eventEmitter.emit(eventName, ...args);
    }

    onAsync(eventName: string, handler: any): BaseComponent {
        this.awaitEventEmitter.on(eventName, handler);

        return this;
    }

    async emitAsync(eventName: string, ...args: any[]) {
        await this.awaitEventEmitter.emit(eventName, ...args);
    }
}
